export const COMPONENT_NAME = "wallet-verification-withdrawal";
